import './index.scss'
$("#nav6").addClass("active");
$(".question .section1 ul li").click(function() {
    $(this).toggleClass("active");
    $(this).find(".answer").slideToggle();
})